import SeafoodHero from '../components/SeafoodHero.jsx';
import LoungeGallery from '../components/LoungeGallery.jsx';

import s1 from './../assets/images/SeafoodLounge/s1.jpg';
import s2 from './../assets/images/SeafoodLounge/s2.jpg';
import s3 from './../assets/images/SeafoodLounge/s3.jpg';
import s4 from './../assets/images/SeafoodLounge/s4.jpg';
import s5 from './../assets/images/SeafoodLounge/s5.jpg';
import s6 from './../assets/images/SeafoodLounge/s6.jpg';
import s7 from './../assets/images/SeafoodLounge/s7.jpg';
import s8 from './../assets/images/SeafoodLounge/s8.jpg';
import s9 from './../assets/images/SeafoodLounge/s9.jpg';
import s10 from './../assets/images/SeafoodLounge/s10.jpg';
import s11 from './../assets/images/SeafoodLounge/s11.jpg';
import s12 from './../assets/images/SeafoodLounge/s12.jpg';
import s13 from './../assets/images/SeafoodLounge/s13.jpg';
import s14 from './../assets/images/SeafoodLounge/s14.jpg';
import s15 from './../assets/images/SeafoodLounge/s15.jpg';

const galleryImages = [s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15];


const SeafoodLounge = () => {
  return (
    <div>
      <SeafoodHero/>
      <LoungeGallery galleryImages={galleryImages}/>
    </div>
  )
}

export default SeafoodLounge